module.exports = __webpack_public_path__ + "img/next-coaching.a8220aff.svg";